import axiosInstance from "./axiosInstance";

export const obtenerTitularLink = async (codigo) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerTitularLink?codigo=${codigo}`
  );
};
